

function Links() {
  return <div className="main-wrapper">
    
      

      <h2>Weiterführende Links und Hilfsangebote</h2>

      <h3>
        Holistische Tanz- und Bewegungstherapie (TherapeutInnen-Netzwerk)
      </h3>

      <a href=" https://holistische-tanztherapie.de" target="_blank" rel="noopener noreferrer">
        holistische-tanztherapie.de
      </a>

      <h3>
        zibko, Zentrum „In BeWEGung kommen", Barbara Hundshammer
      </h3>

      <a href="https://zibko.de" target="_blank" rel="noopener noreferrer">
        zibko.de
      </a>

    </div>
}
export default Links;